import { render, staticRenderFns } from "./team-viewpoints.vue?vue&type=template&id=ab9b1df6&scoped=true&"
import script from "./team-viewpoints.vue?vue&type=script&lang=ts&"
export * from "./team-viewpoints.vue?vue&type=script&lang=ts&"
import style0 from "./team-viewpoints.vue?vue&type=style&index=0&id=ab9b1df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b1df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VCol,VRow,VSwitch,VToolbar,VToolbarTitle})
